var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGifts(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8c-.7-.8-1.7-1.2-3.1-1.4V6A4.9 4.9 0 0 0 8.5 1a5.1 5.1 0 0 0-4.4 5v.6c-1.4.2-2.4.6-3 1.4-1 1-1 2.5-.9 3.5L1 17C1.1 19 2 21 6.2 21h5.6c4.3 0 5-2 5.3-4l.7-5.5c.1-1 .1-2.5-.8-3.5ZM8.7 2.4A3.5 3.5 0 0 1 12.5 6v.7h-7V6c0-1.8 1.5-3.5 3.2-3.7Zm-3.3 9.8a1 1 0 0 1-1-1 1 1 0 0 1 2 0c0 .5-.4 1-1 1Zm7 0a1 1 0 0 1-1-1 1 1 0 0 1 2 0c0 .5-.4 1-1 1Z",
    fill: "#34544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGifts);
export default __webpack_public_path__ + "static/media/gifts.f811c254346167787929ccc68a2b14dc.svg";
export { ForwardRef as ReactComponent };